// business-owner.actions.ts
import { createAction, props } from '@ngrx/store'
// import { BusinessOwner } from './business-owner.state'
import { User } from '../auth/auth.state'

// Action to load businesses
export const loadBusinessOwners = createAction(
  '[BusinessOwner] Load Business owners',
  props<{ params: string | null; page?: number; limit?: number }>()
)

// Action for successful business load
export const loadBusinessOwnersSuccess = createAction(
  '[BusinessOwner] Load Business owners Success',
  props<{
    totalCount: number
    // businessOwners: BusinessOwner[]
    businessOwners: User[]
  }>()
)

// Action for business load failure
export const loadBusinessOwnersFailure = createAction(
  '[BusinessOwner] Load Business owners Failure',
  props<{ error: string }>()
)
